// source: src/common/canvas/canvas_tile.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var src_common_canvas_tile_pb = require('../../../src/common/canvas/tile_pb.js');
goog.object.extend(proto, src_common_canvas_tile_pb);
goog.exportSymbol('proto.loupe.common.canvas.CanvasTile', null, global);
goog.exportSymbol('proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.canvas.CanvasTile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.loupe.common.canvas.CanvasTile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.canvas.CanvasTile.displayName = 'proto.loupe.common.canvas.CanvasTile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.repeatedFields_, null);
};
goog.inherits(proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.displayName = 'proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.canvas.CanvasTile.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.canvas.CanvasTile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.canvas.CanvasTile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasTile.toObject = function(includeInstance, msg) {
  var f, obj = {
    tenantId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    groupId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    userId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    canvasKey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tileKey: jspb.Message.getFieldWithDefault(msg, 5, ""),
    tile: (f = msg.getTile()) && src_common_canvas_tile_pb.Tile.toObject(includeInstance, f),
    layout: (f = msg.getLayout()) && proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    orgDefaultLayout: (f = msg.getOrgDefaultLayout()) && proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.canvas.CanvasTile}
 */
proto.loupe.common.canvas.CanvasTile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.canvas.CanvasTile;
  return proto.loupe.common.canvas.CanvasTile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.canvas.CanvasTile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.canvas.CanvasTile}
 */
proto.loupe.common.canvas.CanvasTile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTenantId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setGroupId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCanvasKey(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTileKey(value);
      break;
    case 6:
      var value = new src_common_canvas_tile_pb.Tile;
      reader.readMessage(value,src_common_canvas_tile_pb.Tile.deserializeBinaryFromReader);
      msg.setTile(value);
      break;
    case 7:
      var value = new proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout;
      reader.readMessage(value,proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.deserializeBinaryFromReader);
      msg.setLayout(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = new proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout;
      reader.readMessage(value,proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.deserializeBinaryFromReader);
      msg.setOrgDefaultLayout(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.canvas.CanvasTile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.canvas.CanvasTile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.canvas.CanvasTile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasTile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getGroupId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCanvasKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTileKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTile();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      src_common_canvas_tile_pb.Tile.serializeBinaryToWriter
    );
  }
  f = message.getLayout();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOrgDefaultLayout();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.serializeBinaryToWriter
    );
  }
};


/**
 * optional string tenant_id = 1;
 * @return {string}
 */
proto.loupe.common.canvas.CanvasTile.prototype.getTenantId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
 */
proto.loupe.common.canvas.CanvasTile.prototype.setTenantId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string group_id = 2;
 * @return {string}
 */
proto.loupe.common.canvas.CanvasTile.prototype.getGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
 */
proto.loupe.common.canvas.CanvasTile.prototype.setGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_id = 3;
 * @return {string}
 */
proto.loupe.common.canvas.CanvasTile.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
 */
proto.loupe.common.canvas.CanvasTile.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string canvas_key = 4;
 * @return {string}
 */
proto.loupe.common.canvas.CanvasTile.prototype.getCanvasKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
 */
proto.loupe.common.canvas.CanvasTile.prototype.setCanvasKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string tile_key = 5;
 * @return {string}
 */
proto.loupe.common.canvas.CanvasTile.prototype.getTileKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
 */
proto.loupe.common.canvas.CanvasTile.prototype.setTileKey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Tile tile = 6;
 * @return {?proto.loupe.common.canvas.Tile}
 */
proto.loupe.common.canvas.CanvasTile.prototype.getTile = function() {
  return /** @type{?proto.loupe.common.canvas.Tile} */ (
    jspb.Message.getWrapperField(this, src_common_canvas_tile_pb.Tile, 6));
};


/**
 * @param {?proto.loupe.common.canvas.Tile|undefined} value
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
*/
proto.loupe.common.canvas.CanvasTile.prototype.setTile = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
 */
proto.loupe.common.canvas.CanvasTile.prototype.clearTile = function() {
  return this.setTile(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.CanvasTile.prototype.hasTile = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional CanvasTileUserDefinedParametersLayout layout = 7;
 * @return {?proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout}
 */
proto.loupe.common.canvas.CanvasTile.prototype.getLayout = function() {
  return /** @type{?proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout} */ (
    jspb.Message.getWrapperField(this, proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout, 7));
};


/**
 * @param {?proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout|undefined} value
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
*/
proto.loupe.common.canvas.CanvasTile.prototype.setLayout = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
 */
proto.loupe.common.canvas.CanvasTile.prototype.clearLayout = function() {
  return this.setLayout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.CanvasTile.prototype.hasLayout = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loupe.common.canvas.CanvasTile.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
*/
proto.loupe.common.canvas.CanvasTile.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
 */
proto.loupe.common.canvas.CanvasTile.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.CanvasTile.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.loupe.common.canvas.CanvasTile.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
*/
proto.loupe.common.canvas.CanvasTile.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
 */
proto.loupe.common.canvas.CanvasTile.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.CanvasTile.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional CanvasTileUserDefinedParametersLayout org_default_layout = 10;
 * @return {?proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout}
 */
proto.loupe.common.canvas.CanvasTile.prototype.getOrgDefaultLayout = function() {
  return /** @type{?proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout} */ (
    jspb.Message.getWrapperField(this, proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout, 10));
};


/**
 * @param {?proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout|undefined} value
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
*/
proto.loupe.common.canvas.CanvasTile.prototype.setOrgDefaultLayout = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.loupe.common.canvas.CanvasTile} returns this
 */
proto.loupe.common.canvas.CanvasTile.prototype.clearOrgDefaultLayout = function() {
  return this.setOrgDefaultLayout(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.loupe.common.canvas.CanvasTile.prototype.hasOrgDefaultLayout = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.prototype.toObject = function(opt_includeInstance) {
  return proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.toObject = function(includeInstance, msg) {
  var f, obj = {
    userQueryParametersIdSortList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    defaultUserQueryParameter: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout}
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout;
  return proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout}
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUserQueryParametersIdSort(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDefaultUserQueryParameter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserQueryParametersIdSortList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getDefaultUserQueryParameter();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated string user_query_parameters_id_sort = 1;
 * @return {!Array<string>}
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.prototype.getUserQueryParametersIdSortList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout} returns this
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.prototype.setUserQueryParametersIdSortList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout} returns this
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.prototype.addUserQueryParametersIdSort = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout} returns this
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.prototype.clearUserQueryParametersIdSortList = function() {
  return this.setUserQueryParametersIdSortList([]);
};


/**
 * optional string default_user_query_parameter = 2;
 * @return {string}
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.prototype.getDefaultUserQueryParameter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout} returns this
 */
proto.loupe.common.canvas.CanvasTileUserDefinedParametersLayout.prototype.setDefaultUserQueryParameter = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


goog.object.extend(exports, proto.loupe.common.canvas);
